/**
 * 单飞（single-flight）：并发调用共享同一次进行中的请求，结束后再调用会重新发起。
 *
 * 场景：`/auth/refresh` 这类**有副作用**的接口 —— 启动流程与 401 拦截器可能在同一瞬间
 * 都需要新 token，各发一次的话，轮换型 refresh token 会被其中一次作废，另一条必然 401
 *（2026-09-25 线上 `401 POST /api/v1/auth/refresh` 的成因）。
 */
export function singleFlight<T>(fn: () => Promise<T>): () => Promise<T> {
  let inflight: Promise<T> | null = null;
  return () => {
    if (!inflight) {
      // 先赋值再挂 finally：保证「同一 tick 内的并发调用」拿到的是同一个 Promise
      inflight = fn().finally(() => {
        inflight = null;
      });
    }
    return inflight;
  };
}
